const addresshelper = {
  formatAddress (streetAddress, postalCode, city): string {
    return [streetAddress, [postalCode, city].filter(Boolean).join(' ')].filter(Boolean).join(', ')
  }
}

export default addresshelper